var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import MeetingModalityService from "../../../Services/MeetingModality.service";
const makeSearchArgs = {
    loadOptions: (search, options) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (options.forceEmptyReturn) {
            return [];
        }
        const response = yield MeetingModalityService.search({
            query: search,
            ids: options.ids,
            excludeIds: options.excludeIds,
            active: options.active,
        }, {
            max: (_a = options.max) !== null && _a !== void 0 ? _a : 20,
            sort: options.sort,
            order: options.order,
            offset: options.offset,
        });
        return response.data;
    }),
    value: "id",
    label: "name",
};
export const MeetingModalitySearch = makeSearch(makeSearchArgs);
export const MeetingModalityMultiSearch = makeMultiSearch(makeSearchArgs);
